import Layout from "hocs/layouts/Layout"
import TripList from "components/Trip/TripList"

import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"

import axios from 'axios';

export default function EventoTrips(){

    const params = useParams()
    const slug = params.slug

    const [eventoDetail, setEventoDetail] = useState({});
    const [isLoading, setIsLoading] = useState(true);

    const config = {
        headers: {
            'Accept': 'application/json'
        }
    };

    useEffect(()=>{
      
        const get_event = async (slug) => {
            try {
                setIsLoading(true)
                const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/events/${slug}`, config);
                if (res.status === 200) {
                    setEventoDetail(res.data.evento)
                } else {
                    setEventoDetail({})
                }
            } catch (err) {
                setEventoDetail({})
            } finally {
                setIsLoading(false)
            }
        }
        get_event(slug)
    }, []);

    return(
        <Layout>
            <TripList evento={eventoDetail} loading={isLoading} slug={slug}/>
        </Layout>
    )
}